import React, { lazy, useState } from 'react';
import { WBIconButton, WBDialog } from '@admiin-com/ds-web';
import InformationIcon from '../../../../../../../assets/icons/information-circle.svg';
const Support = lazy(() => import('../../../../../pages/Support/Support'));

export const SupportDialogButton = () => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <WBIconButton onClick={handleOpen} color="inherit">
        <InformationIcon />
      </WBIconButton>

      <WBDialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
        aria-labelledby="support-dialog-title"
      >
        <Support onClose={handleClose} />
      </WBDialog>
    </>
  );
};
